import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IBank } from '../models/models'

export class GetBankListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'posTransaction',
      requesterInfo,
    })
  }

  public async getParamBankList(): Promise<IBank[]> {
    return await this.getAsync<IBank[]>('bankListParam')
  }

  public async getParatikaBankList(): Promise<IBank[]> {
    return await this.getAsync<IBank[]>('bankListParatika')
  }

  public async getAkOdeBankList(): Promise<IBank[]> {
    return await this.getAsync<IBank[]>('bankListAkOde')
  }
}